import { useTransactions } from 'contexts/Transactions';
import React from 'react';

const IncludeManyPeople = () => {
  const { rewardCustomersIsEnabled } = useTransactions();

  return (
    <div className="vbz-icon-beneficiaries" data-testid="test-include-many-icon">
      <div
        className={
          rewardCustomersIsEnabled ? 'vbz-icon-beneficiaries-include-clients' : 'vbz-icon-beneficiaries-include-many'
        }
      />
    </div>
  );
};

export default IncludeManyPeople;
